import React from 'react';
// template components
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// styles
import {
  LIStyled,
  OLStyled,
  TypographyListCopyStyled,
  TypographyListNumberStyled,
} from './styles';

export default () => {
  return (
    <SectionContainer
      id='fafa-page-numbered-next-steps'
      className='js-show-on-submit'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <Row align='center'>
        <Typography
          component='h2'
          align='center'
          nextElement='graphic'>
          Here&#39;s what will happen next:
        </Typography>
      </Row>
      <Row align='center'>
        <OLStyled>
          <LIStyled>
            <TypographyListNumberStyled
              component='span'
              variant='h1'>
              1.
            </TypographyListNumberStyled>
            <TypographyListCopyStyled>
              You&#39;ll receive a confirmation email at the address you shared with us.
            </TypographyListCopyStyled>
          </LIStyled>
          <LIStyled>
            <TypographyListNumberStyled
              component='span'
              variant='h1'>
              2.
            </TypographyListNumberStyled>
            <TypographyListCopyStyled>
              We&#39;ll send you the name, contact information and website of your match.
            </TypographyListCopyStyled>
          </LIStyled>
          <LIStyled>
            <TypographyListNumberStyled
              component='span'
              variant='h1'>
              3.
            </TypographyListNumberStyled>
            <TypographyListCopyStyled>
              Your advisor will reach out to introduce themselves and get to know you.
            </TypographyListCopyStyled>
          </LIStyled>
        </OLStyled>
      </Row>
    </SectionContainer>
  );
};
